module.exports = __webpack_public_path__ + "img/stained-glass-512.58bfa731.jpg";